import React, { useEffect, useState } from "react";
import { Button, Dialog, EditIcon, PlusIcon, TrashIcon } from "evergreen-ui";
import { Table, Card, Form, Input, Select, message, Popconfirm, Tag, Collapse } from "antd";
import FireFetch from "../../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref, update } from "firebase/database";
import { MDBCol, MDBRow } from "mdbreact";
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import TableActionMenu from "../../../Common/TableActionMenu";
import { filterSelectOption } from "../../../utils/selectOptions.js";

var db = getDatabase(Firebase);
const { Panel } = Collapse;

const GroupTypeLayout = (props) => {
	const canCreate = props.canCreate !== false;
	const canUpdate = props.canUpdate !== false;
	const canDelete = props.canDelete !== false;
	const [form] = Form.useForm();
	const columns = [
		{
			title: 'Type Name',
			dataIndex: 'typeName',
			key: 'typeName',
			width: '20%',
			sorter: (a, b) => a.typeName?.localeCompare(b.typeName),
		},
		{
			title: 'Code',
			dataIndex: 'code',
			key: 'code',
			width: '15%',
			sorter: (a, b) => a.code?.localeCompare(b.code),
		},
		{
			title: 'Translations',
			dataIndex: 'translations',
			key: 'translations',
			render: (translations) => (
				<Collapse ghost size="small">
					<Panel header={`${Object.keys(translations || {}).length} translations`} key="1">
						<div style={{ maxHeight: '200px', overflowY: 'auto' }}>
							{translations && Object.entries(translations).map(([langId, text]) => (
								<Tag key={langId} color="blue" style={{ margin: '4px' }}>
									{text}
								</Tag>
							))}
						</div>
					</Panel>
				</Collapse>
			),
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
			width: '15%',
		}
	];

	const [typeArray, setTypeArray] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [arrayIn, loading] = useListVals(ref(db, "talmidsdb/groupTypes"));
	const [languages] = useListVals(ref(db, "talmidsdb/languages"));
	const [selectedType, setSelectedType] = useState(null);

	useEffect(() => {
		if (arrayIn && languages) {
			const tempArray = arrayIn.map((item, index) => ({
				key: item.id || index,
				id: item.id,
				typeName: item.typeName,
				code: item.code,
				translations: item.translations || {},
				action: (
					<TableActionMenu
						items={[
							canUpdate && {
								key: "edit",
								label: "Edit",
								onClick: () => {
									setSelectedType(item);
									setShowModal(true);
								},
							},
							canDelete && {
								key: "delete",
								label: "Delete",
								danger: true,
								onClick: () => {
									if (confirm("Delete this group type?")) {
										props.messageBack("groupTypes", "delete", item.id);
									}
								},
							},
						]}
					/>
				)
			}));
			setTypeArray(tempArray);
		}
	}, [arrayIn, languages, props, canUpdate, canDelete]);

	const handleEdit = (values) => {
		if (!canUpdate) {
			message.error("You do not have permission to update group types.");
			return;
		}

		const updatedTranslations = {};

		if (values.translations) {
			values.translations.forEach(translation => {
				if (translation.languageId && translation.text) {
					updatedTranslations[translation.languageId] = translation.text;
				}
			});
		}

		const object = {
			typeName: values.translations?.[0]?.text || values.typeName,
			code: values.code,
			translations: updatedTranslations
		};

		update(ref(db, "talmidsdb/groupTypes/" + selectedType.id), object)
			.then(() => {
				message.success("GroupType updated successfully");
				FireFetch.addLog("GroupTypes", selectedType.id, "Edit");
				setShowModal(false);
			})
			.catch((error) => {
				message.error("Unable to update GroupType due to an error: " + error.message);
			});
	}

	const translationsToArray = (translations) => {
		if (!translations) return [];
		return Object.entries(translations).map(([languageId, text]) => ({
			languageId,
			text
		}));
	};

	useEffect(() => {
		if (!showModal || !selectedType) return;

		form.setFieldsValue({
			typeName: selectedType.typeName,
			code: selectedType.code,
			translations: translationsToArray(selectedType.translations),
		});
	}, [form, selectedType, showModal]);

	return (
		<div className="font-Nunito">
			<Dialog
				isShown={showModal}
				title={"Edit Group Type"}
				onCloseComplete={() => { setShowModal(false); }}
				hasFooter={false}
				width="50%"
			>
				<MDBRow>
					<MDBCol className="px-4">
						<Form
							form={form}
							layout="vertical"
							onFinish={handleEdit}
							initialValues={{
								typeName: selectedType?.typeName,
								code: selectedType?.code,
								translations: translationsToArray(selectedType?.translations)
							}}
						>
							<Form.Item
								label="Group Type Name"
								name="typeName"
								rules={[{ required: false, message: 'Please input type name!' }]}
							>
								<Input
									type="text"
									placeholder="enter group type name"
									className="w-100 mr-4"
								/>
							</Form.Item>
							<Form.Item
								label="Group Type Code"
								name="code"
								rules={[{ required: false, message: 'Please input type code!' }]}
							>
								<Input
									type="text"
									placeholder="enter group type code"
									className="w-100 mr-4"
								/>
							</Form.Item>
							<div>
								<Form.List name="translations">
									{(fields, { add, remove }) => (
										<div>
											{fields.map(({ key, name, ...restField }) => (
												<div key={key} style={{
													display: 'flex',
													marginBottom: 8,
													alignItems: 'flex-end',
													gap: '8px'
												}}>
													<Form.Item
														{...restField}
														name={[name, 'languageId']}
														label="Language"
														rules={[{ required: false, message: 'Please select a language!' }]}
														style={{ flex: 1 }}
													>
														<Select
															placeholder="Select language"
															showSearch
															optionFilterProp="children"
															filterOption={filterSelectOption}
														>
															{languages?.map((item) => (
																<Select.Option key={item.id} value={item.id}>
																	{item.languageName}
																</Select.Option>
															))}
														</Select>
													</Form.Item>

													<Form.Item
														{...restField}
														name={[name, 'text']}
														label="Translation"
														rules={[{ required: false, message: 'Please enter translation!' }]}
														style={{ flex: 2 }}
													>
														<Input
															placeholder="Enter translation"
															className="w-100"
														/>
													</Form.Item>

													<Form.Item>
														<MinusCircleOutlined
															onClick={() => remove(name)}
															style={{ color: 'red', marginBottom: '32px' }}
														/>
													</Form.Item>
												</div>
											))}

											<Form.Item>
												<Button
													type="dashed"
													onClick={(e) => {
														e.preventDefault(); // Prevent form submission
														add();
													}}
													block
													icon={<PlusOutlined />}
												>
													Add Translation
												</Button>
											</Form.Item>
										</div>
									)}
								</Form.List>
							</div>

							<Button type="primary" htmlType="submit">
								Save Changes
							</Button>
						</Form>
					</MDBCol>
				</MDBRow>
			</Dialog>

			<div style={{ marginBottom: '16px' }}>
				{canCreate && (
					<Button appearance="primary" className="ml-3 my-2" onClick={() => {
						props.messageBack("groupTypes", "create");
					}}>
						New Type <PlusIcon />
					</Button>
				)}
				<Button appearance="primary" className="mx-2" onClick={() => {
					FireFetch.exportXL(TableExport(document.getElementById("dataTable"), {
						filename: "Group Types",
						exportButtons: false,
						sheetname: "Group Types"
					}), typeArray);
				}}>
					Print
				</Button>
			</div>

			<Card className="d-flex flex-column">
				<Table
					style={{ overflow: "auto" }}
					loading={loading}
					pagination={{
						defaultPageSize: 100,
						showSizeChanger: true,
						pageSizeOptions: ['20', '50', '100']
					}}
					id="dataTable"
					dataSource={typeArray}
					columns={columns}
					scroll={{ x: true }}
				/>
			</Card>
		</div>
	);
}

export default GroupTypeLayout;
